import React from 'react';
import {
    Container,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from "@material-ui/core";
import {Values} from "Tools/Values";
import {NoContentSign} from "@src/Components/Pages/Main/Content/Persons/PersonForm/styles";
import {Location} from "@src/Interfaces/Entity/Location";
import {IValuesStore} from "Stores/Values/types";
import {IManagementStore} from "Stores/Management/types";
import {inject, observer} from "mobx-react";
import {Position} from "@src/Interfaces/Entity/Position";
import {computed, observable} from "mobx";
import {
    PositionTabItem
} from "@src/Components/Pages/Main/Content/Locations/LocationDialog/PositionsTab/PositionTabItem/PositionTabItem";
import {IAuthStore} from "Stores/Auth/types";
import {IError} from "@src/Components/Pages/Main/Content/Locations/LocationDialog/LocationDialog";
import {AddButton} from "@src/Shared/Components/AddButton/AddButton";


interface IPositionsTabProps {
    tableHeight: number;
    positions: Position[];
    location: Location;
    onChange: (positions: Position[]) => void;
    errors: IError[];
    auth?: IAuthStore;
    values?: IValuesStore;
    management?: IManagementStore;
}

@inject("auth", "values", "management")
@observer
export class PositionsTab extends React.Component<IPositionsTabProps> {
    @observable allPositions: Position[] = this.props.management.activePositions;
    @observable takenPositionIds: string[] = this.props.positions.map(item => item.id);

    @computed get adminPositionId() {
        return this.props.values?.common["AdminPositionId"];
    }

    onPositionItemChange(position: Position, index: number) {
        let positions = this.props.positions;
        positions[index] = position;
        this.takenPositionIds = positions.map(item => item.id);
        this.props.onChange(positions);
    }

    onPositionItemRemove(position: Position) {
        this.takenPositionIds = this.takenPositionIds.filter(item => item !== position.id);
        const updatedPositions = this.props.positions.filter(p => p.id !== position.id);
        this.props.onChange(updatedPositions);
    }

    onAddPositionBtnClick() {
        this.props.onChange([...this.props.positions, new Position()]);
    }

    canAddAndEdit() {
        return !this.props.location
            ? true
            : this.props.auth.user.location.primary;
    }

    render() {
        return (
            <Container style={{padding: 0}}>
                <TableContainer
                    style={{maxHeight: `${this.props.tableHeight}px`, overflowY: "auto"}}>
                    <Table>
                        <TableHead style={{backgroundColor: "#f9f9f9"}}>
                            <TableRow>
                                <TableCell style={{width: "30%"}}>{Values.getLocalizationValue("title")}</TableCell>
                                <TableCell style={{width: "30%"}}>{Values.getLocalizationValue("name")}</TableCell>
                                <TableCell style={{width: "30%"}}>{Values.getLocalizationValue("description")}</TableCell>
                                <TableCell/>
                            </TableRow>
                        </TableHead>

                        {(this.props.positions.length > 0)
                            ? <TableBody>
                                {this.props.positions.map((position, index) => (
                                        <PositionTabItem
                                            item={position}
                                            allPositions={this.allPositions}
                                            takenPositionIds={this.takenPositionIds}
                                            error={this.props.errors.find(item => item.index === index)}
                                            onChange={(pos) => this.onPositionItemChange(pos, index)}
                                            onRemove={() => this.onPositionItemRemove(position)}
                                            canEdit={this.canAddAndEdit()}
                                            key={position.id}
                                        />
                                    ))
                                }
                            </TableBody>
                            
                            : <NoContentSign style={{whiteSpace: "nowrap"}}>
                                {Values.getLocalizationValue("listOfPositionsIsEmpty")}
                            </NoContentSign>
                        }
                    </Table>
                </TableContainer>
                
                {this.canAddAndEdit()
                    ? <AddButton
                        onClick={() => this.onAddPositionBtnClick()}
                        text={Values.getLocalizationValue("addPosition")}
                        margin={16}
                    />
                    : <div style={{height: 80}}/>
                }
            </Container>
        );
    }
}
